export default {"src":"/_next/static/media/file-check.55888cd6.svg","height":21,"width":21,"blurWidth":0,"blurHeight":0};